export default __webpack_public_path__ + "static/pizza-guy-3297e6c0dfa7d40c463c61176590baf3.webp";